import { ActionReducerMap } from '@ngrx/store';

import * as fromLoading from './shared/redux/loading.reducer';
import * as fromModule from './shared/redux/modules.reducer';

export interface AppState {
	ui:fromLoading.State,
	module:fromModule.ModuleState;
}
export const appReducers: ActionReducerMap<AppState> ={
	ui:fromLoading.uiReducer,
	module:fromModule.ModuleReducer
};